export default __webpack_public_path__ + "static/media/Endscenario-4.c0a1a822.png";